import '../Finca';

// export {default as SalesList} from './List'
export { default as FincaEditSummary } from './Edit'
